module.exports = __webpack_public_path__ + "img/id-card-front-01.bd56ba98.svg";